"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.bannerTypeColorMap = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = __importDefault(require("react"));
const Warning_1 = __importDefault(require("@kyruus/react-ikons/Warning"));
const InfoCircle_1 = __importDefault(require("@kyruus/react-ikons/InfoCircle"));
const CheckCircle_1 = __importDefault(require("@kyruus/react-ikons/CheckCircle"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.bannerTypeColorMap = {
    alert: {
        icon: 'color_danger',
        border: 'color_danger',
        background: 'color_danger_secondary'
    },
    info: {
        icon: 'color_info',
        border: 'color_info',
        background: 'color_info_secondary'
    },
    warning: {
        icon: 'color_warning',
        border: 'color_warning',
        background: 'color_warning_secondary'
    },
    success: {
        icon: 'color_success',
        border: 'color_success',
        background: 'color_success_secondary'
    },
    default: {
        icon: 'color_border_emphasis',
        border: 'color_border_emphasis',
        background: 'color_providermatch_secondary'
    }
};
const baseIconPositioningCSS = (props) => `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')(props)};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')(props)};
  margin-left: ${(0, ui_theme_1.fromTheme)('spacing_small')(props)};
  float: left;
`;
const styledIconOptions = {
    // Filter includeMargin from being forwarded to the icon to prevent
    // console errors when props are spread in ikon
    shouldForwardProp: (propName) => propName !== 'includeMargin' && propName !== 'type' && propName !== 'icon'
};
const WarningIcon = (0, styled_1.default)((props) => react_1.default.createElement(Warning_1.default, Object.assign({}, props)), styledIconOptions) `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  ${(props) => (props.includeMargin ? baseIconPositioningCSS(props) : '')};
  color: ${(_a) => {
    var { type } = _a, props = __rest(_a, ["type"]);
    return (0, ui_theme_1.fromTheme)(exports.bannerTypeColorMap[type].icon)(props);
}};
`;
const InfoIcon = (0, styled_1.default)((props) => react_1.default.createElement(InfoCircle_1.default, Object.assign({}, props)), styledIconOptions) `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  ${(props) => (props.includeMargin ? baseIconPositioningCSS(props) : '')};
  color: ${(props) => (0, ui_theme_1.fromTheme)(exports.bannerTypeColorMap[props.type].icon)(props)};
`;
const CheckIcon = (0, styled_1.default)((props) => react_1.default.createElement(CheckCircle_1.default, Object.assign({}, props)), styledIconOptions) `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  ${(props) => (props.includeMargin ? baseIconPositioningCSS(props) : '')};
  color: ${(props) => (0, ui_theme_1.fromTheme)(exports.bannerTypeColorMap[props.type].icon)(props)};
`;
const Icon = (props) => {
    if (props.icon !== undefined) {
        if (props.icon === 'i') {
            return react_1.default.createElement(InfoIcon, Object.assign({}, props));
        }
        else if (props.icon === '!') {
            return react_1.default.createElement(WarningIcon, Object.assign({}, props));
        }
        else if (props.icon === 'check') {
            return react_1.default.createElement(CheckIcon, Object.assign({}, props));
        }
        return null;
    }
    else {
        return null;
    }
};
exports.Icon = Icon;
//# sourceMappingURL=styles.js.map